import { AuthenticateChannel } from '@tob/shared/thirdparty-auth/core/types';

/**
 * Use case for third-party authentication flow
 */
export enum ThirdPartyFlowUseCase {
  Login = 'login',
  UserLinkage = 'user-linkage',
}

/**
 * Function type for getting third-party flow trigger URL based on use case
 */
export type GetThirdPartyFlowTriggerUrlFunction = (params: {
  usecase: ThirdPartyFlowUseCase;
}) => string;

/**
 * Function type for getting third-party client ID based on channel
 */
export type GetThirdPartyClientIdFunction = (params: {
  channel: AuthenticateChannel;
}) => string;

export type GetThirdPartyAuthConfigFunction = () => {
  scopes: string[];
  // displayNameTransifyKey will be only used for Shopee Native App OAuth.
  // Shopee App requires display_name parameters.
  // So ToB side will fetch translated text and set for display_name.
  // This transify key should be provided by user-authentication collection (194)
  displayNameTransifyKey: string;
};
